var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"1em"}},[_vm._v("\n    Texte : "),_c('br'),_vm._v("\n    «"+_vm._s(_vm.text.content)+"»\n\t"),_c('hr'),_vm._v(" "),_c('div',[_c('audio',{ref:"listeningTag",attrs:{"src":_vm.soundUrl(),"preload":"auto","controls":""},on:{"ended":function($event){return _vm.reset()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }